import { enqueueSnackbar } from "notistack";
import axiosInstance from "src/utils/axios";
import localStorageAvailable from "src/utils/localStorageAvailable";


const getCampaigns = async (
  user,
  search,
  page,
  sort,
  filter,
  logout,
  campaign_id,
  page_size,
  type
) => {
  const storageAvailable = localStorageAvailable();

  const accessToken = storageAvailable
    ? localStorage.getItem("accessToken")
    : "";

  const sortString = sort
    ? Object.entries(sort)
      .map(([key, value]) => `${key}:${value}`)
      .join(",")
    : "";

  const {
    from_credits,
    till_credits,
    from_date,
    till_date,
    created_by_ids,
    campaign_status,
  } = filter;

  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `/service/campaign_service/v1/campaign/list`,
    headers: {
      authorization: `Bearer ${accessToken}`,
      user,
    },
    params: {
      search,
      page,
      sort: sortString,
      from_credits,
      till_credits,
      from_date,
      till_date,
      created_by_ids,
      campaign_status,
      campaign_id,
      page_size,
      type
    },
  };
  try {
    const response = await axiosInstance.request(config);
    return response;
  } catch (error) {
    if (error?.status === 401) {
      enqueueSnackbar("Un Authorized Request", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      logout();
    }
    if (error?.data === "Verification timeout") {
      return;
    }
    enqueueSnackbar(error?.data?.message || error?.data, {
      variant: "error",
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
  }
};

export default getCampaigns;
